import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';

const inputStyle = { padding: 10, border: '1px solid #ddd', borderRadius: 6, fontSize: '0.9rem', width: '100%' };
const rolColor = { admin: '#ef4444', rrhh: '#f97316', empleado: '#7c6ff7' };
const rolLabel = { admin: 'ADMIN', rrhh: 'RRHH', empleado: 'EMPLEADO' };

function FormEmpleado({ titulo, form, onChange, onGuardar, onCancelar, cargando, esNuevo }) {
  return (
    <div className="upload-card" style={{ marginBottom: 24 }}>
      <h3>{titulo}</h3>
      {esNuevo && (
        <p style={{ fontSize: '0.82rem', color: '#888', marginTop: -4 }}>
          La contraseña inicial será el DNI. El legajo se asigna igual al DNI por defecto.
        </p>
      )}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
        <input name="nombre" placeholder="Nombre completo *" value={form.nombre} onChange={onChange} style={inputStyle} />
        <input name="cargo" placeholder="Cargo" value={form.cargo} onChange={onChange} style={inputStyle} />
        {esNuevo && <input name="email" placeholder="Email *" type="email" value={form.email} onChange={onChange} style={inputStyle} />}
        <input name="dni" placeholder="DNI *" value={form.dni} onChange={onChange} style={inputStyle} />
        <input name="telefono" placeholder="Teléfono" value={form.telefono} onChange={onChange} style={inputStyle} />
        <div>
          <label style={{ fontSize: '0.8rem', color: '#666' }}>Fecha de ingreso</label>
          <input name="fecha_ingreso" type="date" value={form.fecha_ingreso} onChange={onChange} style={{ ...inputStyle, width: '100%' }} />
        </div>
        <div>
          <label style={{ fontSize: '0.8rem', color: '#666' }}>Rol</label>
          <select name="rol" value={form.rol} onChange={onChange} style={{ ...inputStyle, width: '100%' }}>
            <option value="empleado">EMPLEADO</option>
            <option value="rrhh">RRHH</option>
            <option value="admin">ADMIN</option>
          </select>
        </div>
      </div>
      <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 8 }}>
        <button onClick={onCancelar} style={{ padding: '8px 20px', borderRadius: 6, border: 'none', background: '#eee', cursor: 'pointer' }}>
          Cancelar
        </button>
        <button className="btn-subir" onClick={onGuardar} disabled={cargando}>
          {cargando ? 'Guardando...' : '✅ Guardar'}
        </button>
      </div>
    </div>
  );
}

function GestionEmpleados() {
  const [empleados, setEmpleados] = useState([]);
  const [mostrarForm, setMostrarForm] = useState(false);
  const [editando, setEditando] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [form, setForm] = useState({
    nombre: '', cargo: '', email: '', dni: '', legajo: '',
    telefono: '', fecha_ingreso: '', rol: 'empleado'
  });

  useEffect(() => { cargarEmpleados(); }, []);

  async function cargarEmpleados() {
    const { data } = await supabase.from('perfiles').select('*').order('nombre');
    setEmpleados(data || []);
  }

  const handleChange = e => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  function abrirEdicion(emp) {
    setMostrarForm(false);
    setEditando(emp.id);
    setForm({
      nombre: emp.nombre || '',
      cargo: emp.cargo || '',
      email: '',
      dni: emp.cuit || '',
      legajo: emp.legajo || '',
      telefono: emp.telefono || '',
      fecha_ingreso: emp.fecha_ingreso || '',
      rol: emp.rol || 'empleado'
    });
  }

  function abrirNuevo() {
    setEditando(null);
    setForm({ nombre: '', cargo: '', email: '', dni: '', legajo: '', telefono: '', fecha_ingreso: '', rol: 'empleado' });
    setMostrarForm(true);
  }

  async function guardarEdicion() {
    setCargando(true);
    await supabase.from('perfiles').update({
      nombre: form.nombre,
      cargo: form.cargo,
      legajo: form.dni,
      telefono: form.telefono,
      fecha_ingreso: form.fecha_ingreso || null,
      rol: form.rol,
      cuit: form.dni,
    }).eq('id', editando);
    setEditando(null);
    setCargando(false);
    cargarEmpleados();
  }

  async function crearEmpleado() {
    if (!form.email || !form.dni || !form.nombre) {
      alert('Completá nombre, email y DNI como mínimo');
      return;
    }
    alert(`Para crear el usuario:\n\n1. Andá a Supabase → Authentication → Users\n2. Email: ${form.email}\n3. Contraseña: ${form.dni}\n4. Marcá "Auto Confirm User"`);
    setMostrarForm(false);
  }

  async function eliminarEmpleado(id, nombre) {
    if (!window.confirm(`¿Seguro que querés dar de baja a ${nombre}?`)) return;
    await supabase.from('perfiles').delete().eq('id', id);
    cargarEmpleados();
  }

  return (
    <div className="seccion-container">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h2 className="seccion-titulo-pag" style={{ margin: 0 }}>👥 Gestión de empleados</h2>
        <button className="btn-agregar" onClick={abrirNuevo}>+ Nuevo empleado</button>
      </div>

      {mostrarForm && (
        <FormEmpleado
          titulo="Nuevo empleado"
          form={form}
          onChange={handleChange}
          onGuardar={crearEmpleado}
          onCancelar={() => setMostrarForm(false)}
          cargando={cargando}
          esNuevo={true}
        />
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {empleados.map(e => (
          <div key={e.id}>
            {editando === e.id ? (
              <FormEmpleado
                titulo={`Editando: ${e.nombre}`}
                form={form}
                onChange={handleChange}
                onGuardar={guardarEdicion}
                onCancelar={() => setEditando(null)}
                cargando={cargando}
                esNuevo={false}
              />
            ) : (
              <div style={{
                background: 'white', borderRadius: 10, padding: '14px 18px',
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                boxShadow: '0 1px 6px rgba(0,0,0,0.06)'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                  <div style={{
                    width: 42, height: 42, borderRadius: '50%',
                    background: rolColor[e.rol] || '#7c6ff7',
                    color: 'white', display: 'flex', alignItems: 'center',
                    justifyContent: 'center', fontWeight: 700, fontSize: '1.1rem', flexShrink: 0
                  }}>
                    {e.nombre?.charAt(0) || '?'}
                  </div>
                  <div>
                    <div style={{ fontWeight: 700, color: '#1a1a2e', fontSize: '0.95rem' }}>{e.nombre}</div>
                    <div style={{ fontSize: '0.82rem', color: '#888' }}>{e.cargo || '—'}</div>
                    {e.legajo && <div style={{ fontSize: '0.78rem', color: '#aaa' }}>Legajo: {e.legajo}</div>}
                    {e.telefono && <div style={{ fontSize: '0.78rem', color: '#aaa' }}>📞 {e.telefono}</div>}
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{
                    background: rolColor[e.rol] || '#7c6ff7', color: 'white',
                    padding: '3px 12px', borderRadius: 20, fontSize: '0.78rem', fontWeight: 700
                  }}>
                    {rolLabel[e.rol] || 'EMPLEADO'}
                  </span>
                  <button onClick={() => abrirEdicion(e)} style={{
                    background: '#f0f0f0', color: '#333', border: 'none',
                    padding: '6px 12px', borderRadius: 6, cursor: 'pointer', fontSize: '0.82rem', fontWeight: 600
                  }}>
                    ✏️ Editar
                  </button>
                  <button onClick={() => eliminarEmpleado(e.id, e.nombre)} style={{
                    background: '#fef2f2', color: '#ef4444', border: '1px solid #fecaca',
                    padding: '6px 12px', borderRadius: 6, cursor: 'pointer', fontSize: '0.82rem', fontWeight: 600
                  }}>
                    🗑️ Dar de baja
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default GestionEmpleados;